<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ housekeepingServUserManageInfo.servName }}师傅</span>
            <div>
              <el-button type="primary" size="small" @click="_openAddRepairTypeUserModal">
                <i class="el-icon-plus"></i>添加
              </el-button>
              <el-button type="primary" size="small" @click="_goBack">
                <i class="el-icon-close"></i>返回
              </el-button>
            </div>
          </div>

          <el-table :data="housekeepingServUserManageInfo.housekeepingServUsers" style="width: 100%" border stripe>
            <el-table-column prop="staffName" label="员工名称" align="center">
            </el-table-column>
            <el-table-column prop="state" label="员工状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.state == '9999' ? '在线' : '离线' }}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="描述" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="_openDeleteHousekeepingServUserModel(scope.row)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next, jumper" :total="housekeepingServUserManageInfo.total"
            style="margin-top: 20px; text-align: center;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <delete-housekeeping-serv-user ref="deleteHousekeepingServUser" @refresh="query()"></delete-housekeeping-serv-user>
    <select-staff ref="selectStaff"></select-staff>
  </div>
</template>

<script>
import { queryHousekeepingServUser, saveHousekeepingServUser } from '@/api/housekeeping/housekeepingServUserApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'HousekeepingServUserManage',
  components: {
    'delete-housekeeping-serv-user': () => import('@/components/housekeeping/deleteHousekeepingServUser'),
    'select-staff': () => import('@/components/goods/selectStaff')
  },
  data() {
    return {
      housekeepingServUserManageInfo: {
        housekeepingServUsers: [],
        total: 0,
        records: 1,
        servName: '',
        servId: '',
        conditions: {
          state: '',
          shopId: ''
        }
      },
      currentPage: 1,
      pageSize: 10,
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.housekeepingServUserManageInfo.conditions.shopId = this.shopId
    this.housekeepingServUserManageInfo.servId = this.$route.query.servId
    this.housekeepingServUserManageInfo.servName = this.$route.query.servName
    this._listHousekeepingServUsers(1, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listHousekeepingServUsers(val, this.pageSize)
    },
    query(){
      this._listHousekeepingServUsers(this.currentPage, this.pageSize)
    },
    async _listHousekeepingServUsers(page, rows) {
      try {
        const params = {
          ...this.housekeepingServUserManageInfo.conditions,
          page,
          row: rows
        }
        const res = await queryHousekeepingServUser(params)
        this.housekeepingServUserManageInfo.total = res.total
        this.housekeepingServUserManageInfo.records = res.records
        this.housekeepingServUserManageInfo.housekeepingServUsers = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAddRepairTypeUserModal() {
      this.$refs.selectStaff.open({
        call: (staff) => {
          this.saveHousekeepingServUserInfo(staff)
        }
      })
    },
    async saveHousekeepingServUserInfo(staff) {
      try {
        const params = {
          shopId: this.shopId,
          staffId: staff.staffId,
          staffName: staff.staffName,
          servId: this.housekeepingServUserManageInfo.servId,
          state: '9999'
        }
        const res = await saveHousekeepingServUser(params)
        if (res.code === 0) {
          this.$message.success('添加成功')
          this._listHousekeepingServUsers(this.currentPage, this.pageSize)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error('添加失败')
      }
    },
    _openDeleteHousekeepingServUserModel(housekeepingServUser) {
      this.$refs.deleteHousekeepingServUser.open(housekeepingServUser)
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>